<script setup>
import { ref } from 'vue'
import { products } from '@/data/catalog'
import ProductCard from '@/components/ProductCard.vue'
import ProductDialog from '@/components/ProductDialog.vue'

defineProps({
  phone: { type: String, required: true }
})

// La ficha abierta, o null. Una sola para toda la grilla: lo que cambia es qué
// producto le toca, no cuántos diálogos hay en el DOM.
const openProduct = ref(null)
</script>

<template>
  <section id="productos" class="bg-cocoa scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <header class="max-w-2xl">
        <p class="eyebrow text-sand">Lo que fabricamos</p>
        <h2 class="display mt-4 text-balance text-[clamp(1.9rem,4vw,3rem)] text-linen">
          Diferentes maneras de dejar entrar el día
        </h2>
        <p class="mt-4 leading-relaxed text-linen/60">
          Elige por la luz que quieres tener adentro. Toca una para verla de cerca.
        </p>
      </header>

      <!-- Two per row on a phone, scrolling down like the rest of the page. The
           cards get narrow at that width, so they drop to the photo, the name
           and the light meter; the summary and the room come back from sm up,
           where there is room for them. -->
      <div class="mt-10 grid grid-cols-2 gap-x-4 gap-y-9 sm:gap-x-6 lg:mt-12 lg:grid-cols-4 lg:gap-7">
        <ProductCard
          v-for="product in products"
          :key="product.id"
          :product="product"
          @open="openProduct = $event"
        />
      </div>
    </div>

    <ProductDialog :product="openProduct" :phone="phone" @close="openProduct = null" />
  </section>
</template>
